import React from "react";
import { Link } from "react-scroll";
import homeImg from "./assets/TERENCE-bg-0-1.webp";
import "./Home.css";

import { motion } from "framer-motion";
import { externalPofolioContactLink } from "../../constant/constants";
import { NavLink } from "react-router-dom";
const Home = () => {
  return (
    <div className=" bg-primary-color h-full overflow-hidden">
      <div className="grid  grid-rows-2 lg:grid-rows-none  lg:grid-cols-4 h-full">
        <div className="row-span-1 lg:col-start-2 lg:col-span-1 h-full flex justify-center items-center">
          <div className="home text wrapper">
            <motion.div
              animate={{ rotate: 360 }}
              transition={{ duration: 3 }}
              className="home text content"
            >
              <span>H</span>
              <span className="exclamaion mark">!</span>
              <span>There!</span>
            </motion.div>
            <div className="button containa">
              <NavLink to={externalPofolioContactLink} target="_blank" duration={1500}>
                <button className="hire button">Hire Me</button>
              </NavLink>
            </div>
          </div>
        </div>
        <div className="row-span-1 lg:col-start-3 lg:col-span-2 flex justify-center items-center">
          <div className="h-full">
            <img src={homeImg} alt="TERENCE" className="h-fit lg:h-[650px]" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
